import { render, staticRenderFns } from "./boq-root.vue?vue&type=template&id=685a1b0f&scoped=true"
import script from "./boq-root.vue?vue&type=script&lang=js"
export * from "./boq-root.vue?vue&type=script&lang=js"
import style0 from "./boq-root.vue?vue&type=style&index=0&id=685a1b0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685a1b0f",
  null
  
)

export default component.exports